export const FeaturesDataEn = [
  {
    imgUrl: "./algo_icon.png",
    title: "OTM Algorithms",
    url:"/features/otm-algorithms/",

    modalData: {
      imgUrl: "./indicators/OTM_ALGORITHMS.gif",
      title: "OTM Algorithms",

      title2: "Identify absolute market control",
      paragraph2:
        "Detect consecutive bars where buyers or sellers have total dominance, to trade with the prevailing force.",

      title3: "Spot high-aggression phases",
      paragraph3:
        "Anticipate breakouts or sharp trend changes by identifying sequences with high delta and strong momentum.",
    },
  },

  {
    imgUrl: "./swing_icon.png",
    title: "OTM Delta Swing",
    url:"/features/otm-delta-swing/",

    modalData: {
      imgUrl: "./indicators/OTM_SWING.gif",
      title: "OTM Delta Swing",

      title2: "Volume information by waves",
      paragraph2:
        "Compare the strength of a pullback to its initial impulse, this will allow you to better filter your entries.",

      title3: "Opportunity signals for entry",
      paragraph3:
        "Visualize signals of potential buying or selling opportunities. ",
    },
  },
  {
    imgUrl: "./micro_icon.png",
    title: "OTM Delta Micro",
    url:"/features/otm-delta-micro/",
    modalData: {
      imgUrl: "./indicators/OTM_MICRO.gif",
      title: "OTM Delta Micro",

      title2: "Observe large imbalances in the delta",
      paragraph2: "If you want to go long, you need to see large green boxes (buys) from the MicroDelta, and small red boxes (sells) from the MicroDelta. In short, it would be the opposite.",
      
      title3: "Reference thresholds",
      paragraph3:
        "Only pay attention to the most relevant delta boxes using the reference thresholds.",


    },
  },
  {
    imgUrl: "./cumulative_icon.png",
    title: "OTM Delta Cumulative",
    url:"/features/otm-delta-cumulative/",
    modalData: {
      imgUrl: "./indicators/OTM_CUMULATIVE.gif",
      title: "OTM Delta Cumulative",

      title2: "Buy or sell momentum histogram",
      paragraph2: "This histogram allows you to visualize when there is momentum of buying or selling, always enter with momentum when going with the trend.",
      title3: "Detect exhaustion in buyer or seller momentum",
      paragraph3: "Use exhaustion to exit your entries or manage them objectively.",
    },
  },
  {
    imgUrl: "./delta_icon.png",
    title: "OTM Delta Bar",
    url:"/features/otm-delta-bar/",
    modalData: {
      imgUrl: "./indicators/OTM_DELTA_BAR.gif",
      title: "OTM Delta Bar",

      title2: "Buyer or seller force per bar",
      paragraph2: "Get detailed information on the positive or negative delta value of the bars",
      title3: "Volume + Delta",
      paragraph3:
        "View traditional volume bars with color and intensity according to the delta value within the same bar.",
      title4: "Accumulated delta in candles",
      paragraph4:
        "Observe a histogram of the entire Japanese candle session of the delta, use this to detect potential exhaustion and changes in direction.",
    },
  },
  {
    imgUrl: "./profile_icon.png",
    title: "OTM Volume Profile",
    url:"/features/otm-volume-profile/",
    modalData: {
      imgUrl: "./indicators/OTM_PROFILE.gif",
      title: "OTM Volume Profile",

      title2: "Auction information",
      paragraph2: "Get real-time information about the type of day that is being generated, bullish, bearish, or neutral.",
      title3: "Dynamic volume profile",
      paragraph3: "Recreate market movements as if you were in real-time.",
    },
  },
  {
    imgUrl: "./vwap_icon.png",
    title: "OTM VWAP",
    url:"/features/otm-wap/",
    modalData: {
      imgUrl: "./indicators/OTM_VWAP.gif",
      title: "OTM VWAP",

      title2: "Long and Short Indicator",
      paragraph2: "VWAP is the best volume-based tool for separating when to buy and when to sell; if the price is above, you're in a long zone, if the price is below, you're in a short zone.",

      title3: "VWAP Deviations",
      paragraph3:
        "If the price is extending, you can measure through VWAP deviations how far or close it is to its central level and make better decisions.",

    },
  },
];

export const FeaturesDataEs = [
  {
    imgUrl: "./algo_icon.png",
    title: "OTM Algorithms",
    url:"/features/otm-algorithms/",

    modalData: {
      imgUrl: "./indicators/OTM_ALGORITHMS.gif",
      title: "OTM Algorithms",

      title2: "Identifique el control absoluto del mercado",
      paragraph2:
        "Detecte barras consecutivas donde los compradores o vendedores tienen el dominio total, para operar con la fuerza dominante.",

      title3: "Detecte fases de alta agresividad",
      paragraph3:
        "Anticipe rupturas o cambios bruscos de tendencia identificando secuencias con delta elevado y fuerte impulso.",
    },
  },


  {
    imgUrl: "./swing_icon.png",
    title: "OTM Delta Swing",
    url:"/features/otm-delta-swing/",
    modalData: {
      imgUrl: "./indicators/OTM_SWING.gif",
      title: "OTM Delta Swing",

      title2: "Información de volumen por ondas",
      paragraph2:
        "Compare la fuerza que tiene un retroceso respecto a su impulso inicial, así podrá filtrar mejor sus entradas.",

      title3: "Señales de oportunidad de entrada",
      paragraph3:
        "Visualice señales de posibles oportunidades de compra o venta.",
    },
  },
  {
    imgUrl: "./micro_icon.png",
    title: "OTM Delta Micro",
    url:"/features/otm-delta-micro/",
    modalData: {
      imgUrl: "./indicators/OTM_MICRO.gif",
      title: "OTM Delta Micro",

      title2: "Observe grandes desequilibrios en el delta",
      paragraph2: "Si quiere ir largo necesita ver cajas grandes verdes (compras) del MicroDelta, y cajas pequeñas del MicroDelta rojas (ventas). En corto sería lo contrario.",
      
      title3: "Umbrales de referencia",
      paragraph3:
        "Fíjese únicamente las cajas delta más relevantes usando los umbrales de referencia.",


    },
  },
  {
    imgUrl: "./cumulative_icon.png",
    title: "OTM Delta Cumulative",
    url:"/features/otm-delta-cumulative/",
    modalData: {
      imgUrl: "./indicators/OTM_CUMULATIVE.gif",
      title: "OTM Delta Cumulative",

      title2: "Histograma de momentum de compras o ventas",
      paragraph2: "Este histograma le permite visualizar cuando hay momentum de compras o ventas, ingrese siempre con momentum cuando vaya a favor de la tendencia.",

      title3: "Detecte agotamiento en el momentum comprador o vendedor",
      paragraph3: "Utilice los agotamientos para salir de sus entradas o gestionarlas objetivamente.",

    },
  },
  {
    imgUrl: "./delta_icon.png",
    title: "OTM Delta Bar",
    url:"/features/otm-delta-bar/",
    modalData: {
      imgUrl: "./indicators/OTM_DELTA_BAR.gif",
      title: "OTM Delta Bar",

      title2: "Fuerza compradora o vendedora por barra",
      paragraph2: "Obtenga información detallada del valor del delta positivo o negativo de las barras.",
      title3: "Volumen + Delta",
      paragraph3:
        "Visualice las barras de volumen tradicional con el color e intensidad de acuerdo al valor del delta dentro de la misma barra.",
      title4: "Delta acumulado en velas",
      paragraph4:
        "Observe un histograma de toda la sesión de velas japonesas del delta, usa este para detectar posibles agotamientos y cambios de dirección.",
    },
  },
  {
    imgUrl: "./profile_icon.png",
    title: "OTM Volume Profile",
    url:"/features/otm-volume-profile/",
    modalData: {
      imgUrl: "./indicators/OTM_PROFILE.gif",
      title: "OTM Volume Profile",

      title2: "Información de la subasta",
      paragraph2:
        "Obtenga información del tipo de día que se está generando en tiempo real, día alcista, bajista o neutral.",
      title3: "Perfil de volumen dinámico",
      paragraph3:
        "Recree los movimientos del mercado como si estuviera en tiempo real.",
    },
  },
  {
    imgUrl: "./vwap_icon.png",
    title: "OTM VWAP",
    url:"/features/otm-wap/",
    modalData: {
      imgUrl: "./indicators/OTM_VWAP.gif",
      title: "OTM VWAP",

      title2: "Indicador de los largos y cortos",
      paragraph2:
        "El VWAP es la mejor herramienta basada en el volumen para separar cuando comprar y cuando vender; si el precio está por encima, estás en zona de largos, si el precio está por debajo, estás en zona de cortos.",

      title3: "Desviaciones del VWAP",
      paragraph3:
        "Si el precio se extiende puedes medir mediante las desviaciones del VWAP que tan lejos o cerca se encuentra de su nivel central y tomar mejores decisiones.",

    },
  },
];
